import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  IonButton,
  IonInput,
  IonItem,
  IonList,
  IonSelect,
  IonSelectOption,
} from '@ionic/react';
import { getAppError } from '../../utils/messages';
import { uiInputMode } from '../../utils/ui';
import countries from '../../utils/countries';
import { useToaster } from '../../hooks/useToaster';

type PaymentAddFormProps = {
  name: string;
  setName: (s: string) => void;
  addCard: () => void;
  setAddress: (s: string) => void;
  address: string;
  setCity: (s: string) => void;
  city: string;
  setState: (s: string) => void;
  state: string;
  setPostalcode: (s: string) => void;
  postalcode: string;
  setCountry: (s: string) => void;
  country: string;
  setFirstname: (s: string) => void;
  firstname: string;
  setLastname: (s: string) => void;
  lastname: string;
};

export default function PaymentAddForm({
  name,
  setName,
  addCard,
  address,
  setAddress,
  city,
  setCity,
  setState,
  state,
  setPostalcode,
  postalcode,
  setCountry,
  country,
  setFirstname,
  firstname,
  setLastname,
  lastname,
}: PaymentAddFormProps) {
  const [t] = useTranslation('global');
  const [present] = useToaster();

  const validateAndAdd = () => {
    if (!name) {
      present(getAppError(t('payments.errorname')));
      return;
    }
    if (!firstname) {
      present(getAppError(t('payments.errorfirstname')));
      return;
    }
    if (!lastname) {
      present(getAppError(t('payments.errorlastname')));
      return;
    }
    if (!address) {
      present(getAppError(t('payments.erroraddress')));
      return;
    }
    if (!city) {
      present(getAppError(t('payments.errorcity')));
      return;
    }
    if (!state) {
      present(getAppError(t('payments.errorstate')));
      return;
    }
    if (!postalcode) {
      present(getAppError(t('payments.errorpostalcode')));
      return;
    }
    addCard();
  };

  return (
    <>
      <h1 className="h1 pt-2 mb-2">{t('payments.namecard')}</h1>
      <IonList inset={false} className="ion-no-padding">
        <IonItem lines="none" className="ion-no-padding">
          <IonInput
            value={name}
            mode={uiInputMode()}
            aria-label={t('payments.entername')!}
            placeholder={t('payments.entername')!}
            onIonInput={(e) => setName(e.detail.value!)}
            type="text"
            fill="outline"
          ></IonInput>
        </IonItem>
      </IonList>

      <h1 className="h1 pt-2 mb-2">{t('payments.billingaddress')}</h1>
      <IonList inset={false} className="ion-no-padding">
        <IonItem lines="none" className="ion-no-padding pb-1">
          <IonInput
            value={firstname}
            mode={uiInputMode()}
            aria-label={t('payments.firstname')!}
            placeholder={t('payments.firstname')!}
            onIonInput={(e) => setFirstname(e.detail.value!)}
            type="text"
            fill="outline"
          ></IonInput>
        </IonItem>
        <IonItem lines="none" className="ion-no-padding pb-1">
          <IonInput
            value={lastname}
            mode={uiInputMode()}
            aria-label={t('payments.lastname')!}
            placeholder={t('payments.lastname')!}
            onIonInput={(e) => setLastname(e.detail.value!)}
            type="text"
            fill="outline"
          ></IonInput>
        </IonItem>
        <IonItem lines="none" className="ion-no-padding pb-1">
          <IonInput
            value={address}
            mode={uiInputMode()}
            aria-label={t('payments.address')!}
            placeholder={t('payments.address')!}
            onIonInput={(e) => setAddress(e.detail.value!)}
            type="text"
            fill="outline"
          ></IonInput>
        </IonItem>
        <IonItem lines="none" className="ion-no-padding pb-1">
          <IonInput
            mode={uiInputMode()}
            value={city}
            aria-label={t('payments.city')!}
            placeholder={t('payments.city')!}
            onIonInput={(e) => setCity(e.detail.value!)}
            type="text"
            fill="outline"
          ></IonInput>
        </IonItem>
        <IonItem lines="none" className="ion-no-padding pb-1">
          <IonInput
            value={state}
            mode={uiInputMode()}
            aria-label={t('payments.state')!}
            placeholder={t('payments.state')!}
            onIonInput={(e) => setState(e.detail.value!)}
            type="text"
            fill="outline"
          ></IonInput>
        </IonItem>
        <IonItem lines="none" className="ion-no-padding pb-1">
          <IonInput
            value={postalcode}
            mode={uiInputMode()}
            aria-label={t('payments.postalcode')!}
            placeholder={t('payments.postalcode')!}
            onIonInput={(e) => setPostalcode(e.detail.value!)}
            type="text"
            fill="outline"
          ></IonInput>
        </IonItem>
        <IonItem lines="none" className="ion-no-padding pb-1 pseudo-select">
          <IonSelect
            value={country}
            mode={uiInputMode()}
            aria-label={t('payments.country')!}
            placeholder={t('payments.country')!}
            onIonChange={(e) => setCountry(e.detail.value!)}
          >
            {countries.map((country) => (
              <IonSelectOption key={country.name} value={country.name}>
                {country.name}
              </IonSelectOption>
            ))}
          </IonSelect>
        </IonItem>
      </IonList>

      <div className="pt-3 ion-text-center">
        <IonButton
          className={'btn-default btn-wide-80'}
          onClick={() => validateAndAdd()}
        >
          {t('payments.addcard')}
        </IonButton>
      </div>
    </>
  );
}
